import { FC, useRef, useState } from "react";
import { type ContextMenuAction, ModalDialog, TableCell, TableHeadCell, TableRow, useDebounce } from "@rothoblaas/design-system";
import Table from "../../components/ui/Table";
import { getEditAction } from "../../utils/rowActions";
import useListFilters from "../../hooks/useListFilters";
import useI18n from "../../hooks/useTranslations";
import { SearchCategory } from "../../http/types/categories";
import { useCategoriesApi } from "../../http/useCategories";
import { PaginationQuery } from "../../types";
import { AdminCategoryModal } from "./AdminCategoryModal";
interface CategoryModalProps {
  onClose: () => void;
}

const AdminCategoriesModal: FC<CategoryModalProps> = ({ onClose }) => {
  const i18n = useI18n();

  const filters = useListFilters({ isSearchable: true });
  const debouncedValue = useDebounce(filters.state.q);
  const aborter = useRef(new AbortController());
  const query: PaginationQuery = {
    ...filters.state,
    q: debouncedValue,
  };
  const data = useCategoriesApi().useAdminCategories(query, aborter.current.signal).data;
  const [itemToEdit, setItemToEdit] = useState<SearchCategory>();

  const getRowActions = (item: SearchCategory): ContextMenuAction[] => {
    const actions: ContextMenuAction[] = [];

    actions.push(getEditAction(i18n, () => setItemToEdit(item)));
    return actions;
  };

  return (
    <>
      <ModalDialog onClose={onClose} title={i18n.translation.categories.all}>
        <Table<SearchCategory>
          filters={filters}
          head={
            <TableRow>
              <TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>
              <TableHeadCell></TableHeadCell>
            </TableRow>
          }
          search={{
            placeholder: i18n.translation.clients.search,
            onChange: () => {
              aborter.current.abort();
              aborter.current = new AbortController();
            },
          }}
          onRowClick={(item, event) => {
            event.preventDefault();
            setItemToEdit(item);
          }}
          renderRow={(item) => (
            <>
              <TableCell>{item.name}</TableCell>
            </>
          )}
          rowActions={getRowActions}
          //   error={result.error}
          items={data?.items}
          total={data?.total}
        />
      </ModalDialog>

      {!!itemToEdit && (
        <AdminCategoryModal
          categoryCode={itemToEdit.code}
          onCloseModal={() => setItemToEdit(undefined)}
        ></AdminCategoryModal>
      )}
    </>
  );
};

export default AdminCategoriesModal;
